import axios from "axios";
import { environment } from "../../environments/environment";

export const IpAddressRepository = axios.create({
  baseURL: environment.ipFinderUrl,
  headers: {}
});

IpAddressRepository.interceptors.request.use(
  config => {
    if (requestHeaders.contentType) {
      config.headers["Content-Type"] = requestHeaders.contentType;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

let requestHeaders = {
  contentType: "application/json"
};

export default {
  setContentType(contentType) {
    requestHeaders.contentType = contentType;
  }
};


